import React from 'react';

import { Switch } from '@mui/material';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';

import TextCellSkeleton from 'components/SkeletonScreen/components/TextCellSkeleton';
import formEngineStyle from 'theme/formEngine-theme';

export const SwitchCell = ({
  disabled = false,
  classes,
  onValueChange = () => null,
  value,
  loading,
}) => {
  if (loading) {
    return <TextCellSkeleton />;
  }

  return (
    <Switch
      checked={value}
      onChange={onValueChange}
      disabled={disabled}
      classes={{
        switchBase: classes.switchBase,
        icon: classes.switchIcon,
        checked: classes.switchChecked,
        disabled: classes.switchDisabled,
        track: classes.track,
      }}
    />
  );
};

SwitchCell.propTypes = {
  classes: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  value: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onValueChange: PropTypes.func,
};

export default withStyles(formEngineStyle)(SwitchCell);
